import $ from 'jquery';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import cn from 'classnames';

import BrIcons from '@components/BrIcons';
import BrLabel from '@components/BrLabel';
import 'bootstrap-daterangepicker/daterangepicker.css';
import './brDateRangePicker.scss';

const startOfToday = moment().startOf('day');
const getValidDate = (momentDate) => (momentDate && moment(momentDate).isValid() ? moment(momentDate) : startOfToday);

export default class BrDateRangePicker extends PureComponent {
  static propTypes = {
    start: PropTypes.any,
    end: PropTypes.any,
    minDate: PropTypes.any,
    open: PropTypes.oneOf(['left', 'right']),
    onApply: PropTypes.func.isRequired,
  };

  static defaultProps = {
    start: startOfToday,
    end: startOfToday,
    minDate: startOfToday,
    onApply: null,
    open: 'left',
  };

  constructor(props) {
    super(props);
    this.state = {
      predefinedDateRanges: {
        'All Time': [startOfToday, startOfToday],
        Today: [moment().startOf('day'), moment().endOf('day')],
        Tomorrow: [moment().add(1, 'days').startOf('day'), moment().add(1, 'days').endOf('day')],
        'Next 7 Days': [moment().startOf('day'), moment().add(6, 'days').endOf('day')],
        'Next 30 Days': [moment().startOf('day'), moment().add(29, 'days').endOf('day')],
        'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day')],
        'Next Month': [
          moment().add(1, 'month').startOf('month').startOf('day'),
          moment().add(1, 'month').endOf('month').endOf('day'),
        ],
      },
      start: getValidDate(this.props.start),
      end: getValidDate(this.props.end),
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      getValidDate(nextProps.start).valueOf() !== getValidDate(this.props.start).valueOf()
      || getValidDate(nextProps.end).valueOf() !== getValidDate(this.props.end).valueOf()
    ) {
      this.setState({
        start: getValidDate(nextProps.start),
        end: getValidDate(nextProps.end),
      });
    }
  }

  setTimeLocale() {
    const zoneAbbr = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
    const timeZone = $(`<span class="time-zone"> ${zoneAbbr} </span>`);
    this.find('.calendar-time i').remove();
    if (!this.find('.left .calendar-time span').length) {
      this.find('.left .calendar-time .ampmselect').after(timeZone);
    }
    if (!this.find('.right .calendar-time span').length) {
      this.find('.right .calendar-time .ampmselect').after(timeZone);
    }
  }

  handleShowCalendar = (e, picker) => {
    const { container } = picker;
    if (e.type === 'show') {
      container.find('.calendar').on('DOMNodeInserted', this.setTimeLocale.bind(container));
      this.setTimeLocale.bind(container)();
    } else {
      container.find('.calendar').off('DOMNodeInserted');
    }
  };

  handleApplyDateRange(e, picker) {
    this.setState({
      start: picker.startDate,
      end: picker.endDate,
    });
    const durationObj = {
      start: picker.startDate.valueOf(),
      end: picker.endDate.valueOf(),
      chosenLabel: picker.chosenLabel,
    };
    if (picker.chosenLabel === 'All Time') {
      durationObj.start = null;
      durationObj.end = null;
    }
    this.props.onApply(durationObj);
  }

  render() {
    const { open, className, minDate } = this.props;
    const { start, end, predefinedDateRanges } = this.state;
    const dateRangeStr = start.isSame(startOfToday) && end.isSame(startOfToday)
      ? 'All Time'
      : `${moment(start).format('YYYY-MM-DD HH:mm')} - ${moment(end).format('YYYY-MM-DD HH:mm')}`;
    const locale = { applyLabel: 'Done', cancelLabel: 'Cancel' };
    const pickerClassName = cn('br-daterange-picker', className);
    return (
      <DateRangePicker
        initialSettings={{
          startDate: moment(start),
          endDate: moment(end),
          minDate: moment(minDate),
          ranges: predefinedDateRanges,
          opens: open,
          timePicker: true,
          locale,
        }}
        onApply={this.handleApplyDateRange.bind(this)}
        onEvent={this.handleShowCalendar}
        data-id="br-daterange-picker"
      >
        <div className={pickerClassName} data-id="br-daterange-picker">
          <BrIcons.Calendar className="date-range-cal-icon" isSubComp />
          <BrLabel className="br-daterange-display-label" title={dateRangeStr} />
          <BrIcons.DownCaret isSubComp />
        </div>
      </DateRangePicker>
    );
  }
}
